import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CalendarAppointmentsWrapperComponent } from '../../components/calendar-appointments-wrapper/calendar-appointments-wrapper.component';

@Component({
  standalone: true,
  selector: 'app-appointments',
  templateUrl: './appointments.component.html',
  styleUrls: ['./appointments.component.scss'],
  imports: [CalendarAppointmentsWrapperComponent, TranslateModule],
})
export class AppointmentsComponent {
  date: string;
  constructor(private route: ActivatedRoute) {
    this.route.queryParams.subscribe((params) => {
      const date = params['date'];
      this.date = date;
    });
  }
}
